import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import * as Sentry from '@sentry/react';
import { AuthProvider } from './context/AuthContext.tsx';
import { FirebaseProvider } from './context/FirebaseContext.tsx';
import { initTelemetry, isSentryEnabled } from './lib/analytics';
import './index.css';
import App from './App.tsx';

initTelemetry();

const app = (
  <StrictMode>
    <AuthProvider>
      <FirebaseProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FirebaseProvider>
    </AuthProvider>
  </StrictMode>
);

const crashFallback = (
  <div className="flex min-h-screen items-center justify-center">
    <p role="alert" className="text-sm text-foreground">
      Coś poszło nie tak. Odśwież stronę.
    </p>
  </div>
);

createRoot(document.getElementById('root')!).render(
  isSentryEnabled() ? (
    <Sentry.ErrorBoundary fallback={crashFallback}>{app}</Sentry.ErrorBoundary>
  ) : (
    app
  ),
);
